import { minutesToMilliseconds } from 'date-fns'

import { useMunicipalitiesServiceGetV1Municipalities } from '../client/queries'

export const useMunicipalities = () => {
  return useMunicipalitiesServiceGetV1Municipalities(undefined, {
    staleTime: minutesToMilliseconds(5),
  })
}
